import Checkbox, { CheckboxProps } from './Checkbox';

export type { CheckboxProps };
export default Checkbox;
